(function ($) {
	
	var $rhhaddressconfirmation = $( '#rhh-address-confirmation' );
	
	if ( $rhhaddressconfirmation.length > 0 ) {
		
		$rhhaddressconfirmation.find( '.verify' ).click ( function( e ) {
			e.preventDefault();
			$( '#rhh-address-confirmation' ).find( '.screen' ).show();
			ModeEffectPro.post( 'rhh_confirm_addresses', {}, function ( response ) {
				$.jqmodal.close();
			} );
			return false;
		});
		
		$rhhaddressconfirmation.jqmodal( {
			blockerClass: 'checkout-cta',
			escapeClose: false,
			clickClose: false,
			showClose: false
		} );
		
	}
	
})(jQuery);